import { Routes } from '@angular/router'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { UISettingsComponent } from './ui-settings.component'

export const uiRoutes: Routes = [
  {
    path: 'admin/settings/ui_settings',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: UISettingsComponent,
        data: {
          permissions: {
            only: 'SYSTEM_SETTINGS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
